import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/ui-kit";
import CalendarView from "@/components/calendar/CalendarView";
import { EventDetail } from "@/components/calendar/EventDetail";

export default function StudentCalendar() {
  const navigate = useNavigate();
  const [ev, setEv] = useState(null);
  const openHw = (e) => navigate(e.is_writing ? `/student/writing/${e.homework_id}` : "/student/homework");
  return (
    <div className="animate-fade-up" data-testid="student-calendar-page">
      <PageHeader title="Calendar" subtitle="Your classes, mock exams, homework deadlines and key exam dates." />
      <CalendarView onEventClick={setEv} />
      <EventDetail ev={ev} onClose={() => setEv(null)} onOpenHomework={openHw} />
    </div>
  );
}
